import React, { useContext } from 'react'
import { FaWhatsapp } from "react-icons/fa";
import { UserContext } from '../App';
import "./Footer.css";
import {motion} from 'framer-motion';
import {fadeIn} from './variants'

function Footer() {
  const {theme,seTheme}=useContext(UserContext);
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "3467313e-6c51-474f-930a-7b15cc88b310");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className={theme==0?'footer-main-light':'footer-main-dark'} >
      <center id={theme==0?'talk-bg-light':'talk-bg-dark'} style={{marginBottom:"2rem"}}>Contact</center>
      <div className={theme==0?'footer-light':'footer-dark'}>
        <div id='links' className={theme==0?'con-1-light':'con-1-dark'}>
          <motion.a
                               variants={fadeIn("up",0.2)}
                               initial="hidden"
                               whileInView={"show"}
                               viewport={{once:false,amount:0.7}}
           href="tel:+919347796811">Call - +91 9347796811</motion.a>
          <motion.a 
                               variants={fadeIn("up",0.2)}
                               initial="hidden"
                               whileInView={"show"}
                               viewport={{once:false,amount:0.7}}
          href="email:popurimurali16@gmail.com">Gmail - popurimurali16@gmail.com</motion.a>
        </div>
        <div className={theme==0?'con-2-light':'con-2-dark'}>
          <h3>Direct Message</h3>
          <form id='form' onSubmit={onSubmit}>
            <input  type="text" placeholder='Full Name' name='name' required/>
            <input   type="email" placeholder='Email' name='email'required/>
            
            <input style={{height:'2rem'}}  placeholder='Message' name='message' required/>
            <div id="btn" style={{width:"100%"}}>
          <button className={theme==0?'btn-light':'btn-dark'}>Send</button>
          </div>
          </form>
  
          
        </div>
      </div>
    </div>
  )
}

export default Footer